var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"regenerate-button",attrs:{"title":_vm.title}},[_c('i',{staticClass:"fa fa-recycle regenerate-icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }